module.exports = __webpack_public_path__ + "static/media/star_off.2c965993.png";